import PropTypes from 'prop-types';
import React from 'react';

/** The "‹ Back" affordance shown top-left inside each resolution step. */
const StepBack = ({ onBack }) => (
  <button type="button" className="resolve__back" onClick={onBack}>
    <span aria-hidden="true">‹</span> Back
  </button>
);

StepBack.propTypes = { onBack: PropTypes.func.isRequired };

export { StepBack };
